import { createTheme } from "@mui/material/styles";
import { Theme } from "@mui/material/styles";

// Brand Colors
const BRAND = {
  primary: "#3B82F6",
  background: "#192231",
  white: "#FFFFFF",
  card: "#0e0e0e",
};

const getLanguageSpecificFontFamily = (direction: "ltr" | "rtl") =>
  direction === "rtl"
    ? '"Noto Sans Arabic", "Roboto", sans-serif'
    : '"Roboto", sans-serif';

export const createAppTheme = (direction: "ltr" | "rtl"): Theme =>
  createTheme({
    direction,
    typography: {
      fontFamily: getLanguageSpecificFontFamily(direction),
      h1: {
        fontWeight: 500,
      },
      h2: {
        fontWeight: 500,
      },
      h3: {
        fontWeight: 500,
      },
      h4: {
        fontWeight: 500,
      },
      h5: {
        fontWeight: 500,
      },
      h6: {
        fontWeight: 500,
      },
      subtitle1: {
        fontWeight: 400,
      },
      subtitle2: {
        fontWeight: 400,
      },
      body1: {
        fontWeight: 400,
      },
      body2: {
        fontWeight: 400,
      },
      button: {
        fontWeight: 500,
        textTransform: "none",
      },
    },
    palette: {
      mode: "dark",
      background: {
        default: BRAND.background,
        paper: BRAND.card,
      },
      primary: {
        main: BRAND.primary,
        contrastText: BRAND.white,
      },
      text: {
        primary: BRAND.white,
        secondary: "#e8eaed",
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: "inherit",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontFamily: "inherit",
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontFamily: "inherit",
          },
        },
      },
      MuiCircularProgress: {
        styleOverrides: {
          root: {
            color: BRAND.primary,
          },
        },
      },
    },
  });

// Performance optimization: Preload critical assets
export const preloadAssets = () => {
  // Preload Roboto font
  const robotoLink = document.createElement("link");
  robotoLink.rel = "preload";
  robotoLink.as = "style";
  robotoLink.href =
    "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap";
  document.head.appendChild(robotoLink);

  // Preload Noto Sans Arabic font
  const notoArabicLink = document.createElement("link");
  notoArabicLink.rel = "preload";
  notoArabicLink.as = "style";
  notoArabicLink.href =
    "https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@100;200;300;400;500;600;700;800;900&display=swap";
  document.head.appendChild(notoArabicLink);
};
